import { useMutation } from "react-query";
import { botLocalAxios, botSecureAxios } from "./bot";
import { useItems, useItemsFine } from "./app/items";
import { result } from "lodash";
import { queryClient } from "../_helpers/query";

export const useOrderMutation = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/payment/create_order`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                queryClient.invalidateQueries(["items", "qdb_order"]);
            },
        }
    );
};

export const useVerifyPayment = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/payment/verify_payment`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                queryClient.invalidateQueries(["items", "qdb_order"]);
            },
        }
    );
};
